import { hosts } from 'settings';

export const FooterMain = {
  template: `
    <footer class="footer-main pb-2">
      <div class="footer-edge">
        <div class="edge-inner">
          <div class="edge-left"></div>
          <div class="edge-shape"></div>
          <div class="edge-right"></div>
        </div>
      </div>
      <div class="footer-content col-lg-8 mx-auto text-center pt-2">
        <p class="text-teal-dark d-flex justify-content-center align-items-center mb-1 font-weight-semibold">
          from the team at <i class="logo logo-12wbt ml-1">12WBT</i>
        </p>
        <p>
          Consult your healthcare professional before beginning any diet or
          fitness regime.
        </p>
        <hr>
        <p class="text-teal-dark d-flex justify-content-center align-items-center mb-1">
          <i class="fa fa-instagram"></i>
          <span class="pl-1 pr-1">Follow us</span>
          <strong>
            <a class="text-teal-dark"
              href="https://instagram.com/voomeHQ/"
              target="_blank">
              @voomeHQ
            </a>
          </strong>
        </p>
        <p>
          <a class="text-gray" href="${hosts.public}/terms">
            Terms &amp; Conditions
          </a>
          <span class="text-gray px-2">|</span>
          <a class="text-gray" href="${hosts.public}/privacy">
            Privacy
          </a>
          <span class="text-gray px-2">|</span>
          <a class="text-gray" href="${hosts.public}/contact-us">
            Contact Us
          </a>
        </p>
      </div>
    </footer>`,
};



// WEBPACK FOOTER //
// ./src/components/Footer/FooterMain.js